import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, Lock, AlertCircle, ArrowRight, X } from 'lucide-react';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}
interface UpsellPopupProps {
  isOpen: boolean;
  onClose: () => void;
}
export function UpsellPopup({
  isOpen,
  onClose
}: UpsellPopupProps) {
  const FULL_BUNDLE_URL = 'https://rutinasimple.com//cart/52255237472537:1';
  const MAIN_PRODUCT_URL = 'https://rutinasimple.com//cart/52146528747801:1';
  const handleAccept = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Full Bundle Upsell'
      });
    }
    window.location.href = FULL_BUNDLE_URL;
  };
  const handleDecline = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Main Product Only'
      });
    }
    window.location.href = MAIN_PRODUCT_URL;
  };
  return <AnimatePresence data-id="element-262">
      {isOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-263">
          {/* Dark Overlay */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-deep-charcoal/80 backdrop-blur-sm" data-id="element-264" />

          {/* Popup Content */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="relative w-full max-w-2xl bg-white rounded-3xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]" data-id="element-265">
            {/* Close Button */}
            <button onClick={onClose} className="absolute top-4 right-4 z-10 p-2 bg-black/10 hover:bg-black/20 rounded-full text-deep-charcoal transition-colors" data-id="element-266">
              <X className="w-5 h-5" data-id="element-267" />
            </button>

            {/* Header Banner */}
            <div className="bg-dusty-rose text-white p-6 text-center relative overflow-hidden" data-id="element-268">
              <div className="absolute inset-0 opacity-10 mix-blend-overlay" style={{
            backgroundImage: "url('https://www.transparenttextures.com/patterns/cubes.png')"
          }} data-id="element-269"></div>
              <div className="relative z-10" data-id="element-270">
                <div className="inline-flex items-center gap-2 bg-white/20 px-3 py-1 rounded-full text-sm font-bold uppercase tracking-wider mb-3" data-id="element-271">
                  <AlertCircle className="w-4 h-4" data-id="element-272" />
                  Oferta Única
                </div>
                <h2 className="text-2xl sm:text-3xl font-heading font-bold mb-2" data-id="element-273">
                  ¡ESPERA! 🛑 No te vayas con el trabajo a medias
                </h2>
                <p className="text-white/90 text-sm sm:text-base font-medium" data-id="element-274">
                  Tengo algo especial para asegurar tu transformación de 28
                  días...
                </p>
              </div>
            </div>

            {/* Scrollable Body */}
            <div className="p-6 sm:p-8 overflow-y-auto" data-id="element-275">
              {/* Flashing Discount Badge & Copy */}
              <div className="text-center mb-8" data-id="element-276">
                <div className="inline-block animate-pulse bg-sage-green text-white px-4 py-1.5 rounded-full font-bold text-lg mb-4 shadow-lg" data-id="element-277">
                  ¡30% DE DESCUENTO EN TODOS LOS COMPLEMENTOS!
                </div>
                <p className="text-deep-charcoal text-base sm:text-lg font-medium leading-relaxed mb-2" data-id="element-278">
                  Para sincronizar tu metabolismo con tus 4 fases hormonales y
                  eliminar la inflamación por completo, necesitas el sistema
                  entero.
                </p>
                <p className="text-deep-charcoal/70 text-sm sm:text-base" data-id="element-279">
                  Llévate el paquete completo con todos los aceleradores de
                  resultados por una fracción de su precio.
                </p>
              </div>

              {/* What's Included List */}
              <div className="bg-warm-beige/30 rounded-2xl p-5 sm:p-6 mb-8 border border-warm-beige" data-id="element-280">
                <h3 className="font-bold text-deep-charcoal mb-4 text-center uppercase tracking-wider text-sm" data-id="element-281">
                  Lo que incluye el Paquete Completo:
                </h3>
                <ul className="space-y-3" data-id="element-282">
                  <li className="flex items-start gap-3" data-id="element-283">
                    <CheckCircle2 className="w-5 h-5 text-sage-green flex-shrink-0 mt-0.5" data-id="element-284" />
                    <div data-id="element-285">
                      <span className="font-bold text-deep-charcoal" data-id="element-286">
                        Pack Código Hormonal 28D
                      </span>
                      <span className="text-deep-charcoal/70 text-sm block" data-id="element-287">
                        Incluye Guía Maestra, Recetario, Calendario Fitness y
                        Protocolos SOS
                      </span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-288">
                    <CheckCircle2 className="w-5 h-5 text-dusty-rose flex-shrink-0 mt-0.5" data-id="element-289" />
                    <div data-id="element-290">
                      <span className="font-bold text-deep-charcoal" data-id="element-291">
                        Protocolo Adiós-Cafeína
                      </span>
                      <span className="text-deep-charcoal/70 text-sm block" data-id="element-292">
                        Hack del aceite y 3 sustitutos para restaurar tu energía
                        real en 7 días
                      </span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-293">
                    <CheckCircle2 className="w-5 h-5 text-dusty-rose flex-shrink-0 mt-0.5" data-id="element-294" />
                    <div data-id="element-295">
                      <span className="font-bold text-deep-charcoal" data-id="element-296">
                        Lista de Súper Inteligente
                      </span>
                      <span className="text-deep-charcoal/70 text-sm block" data-id="element-297">
                        Qué comprar según tu fase y los 7 ingredientes que
                        disparan tu insulina
                      </span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-298">
                    <CheckCircle2 className="w-5 h-5 text-dusty-rose flex-shrink-0 mt-0.5" data-id="element-299" />
                    <div data-id="element-300">
                      <span className="font-bold text-deep-charcoal" data-id="element-301">
                        Diario de Señales Biológicas
                      </span>
                      <span className="text-deep-charcoal/70 text-sm block" data-id="element-302">
                        Predice humor, antojos y descubre tu semáforo de
                        inflamación diario
                      </span>
                    </div>
                  </li>
                </ul>
              </div>

              {/* Pricing Block */}
              <div className="text-center mb-8" data-id="element-303">
                <div className="flex items-center justify-center gap-3 mb-1" data-id="element-304">
                  <span className="text-deep-charcoal/50 font-medium line-through text-lg" data-id="element-305">
                    $34.16 USD
                  </span>
                  <span className="text-4xl sm:text-5xl font-bold text-dusty-rose" data-id="element-306">
                    $28.41 <span className="text-2xl" data-id="element-307">USD</span>
                  </span>
                </div>
                <div className="flex items-center justify-center gap-2 text-sm text-sage-green font-bold bg-sage-green/10 inline-flex px-3 py-1 rounded-full mt-2" data-id="element-308">
                  <Lock className="w-4 h-4" data-id="element-309" />
                  Precio especial solo disponible en esta pantalla
                </div>
              </div>

              {/* CTA Buttons */}
              <div className="space-y-4" data-id="element-310">
                <button onClick={handleAccept} className="group relative w-full flex items-center justify-center px-6 py-4 sm:py-5 text-base sm:text-lg font-bold text-white transition-all duration-300 bg-dusty-rose rounded-2xl hover:bg-dusty-rose/90 hover:shadow-xl hover:-translate-y-1 overflow-hidden" data-id="element-311">
                  <div className="absolute inset-0 bg-white/20 w-full h-full -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-312"></div>
                  SÍ! QUIERO EL PAQUETE COMPLETO POR $28.41 USD
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-313" />
                </button>

                <button onClick={handleDecline} className="w-full text-center py-3 text-sm sm:text-base font-medium text-deep-charcoal/60 hover:text-deep-charcoal transition-colors underline underline-offset-4" data-id="element-314">
                  No gracias, continuaré sin los aceleradores de resultados →
                </button>
              </div>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}